"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toBn = _interopRequireDefault(require("../hex/toBn"));

// Copyright 2017-2020 @polkadot/util authors & contributors
// SPDX-License-Identifier: Apache-2.0

/**
 * @name bnFromHex
 * @summary Creates a BN.js bignumber object from a hex string.
 * @alias hex/toBn
 */
var _default = _toBn.default;
exports.default = _default;